module.exports = __webpack_public_path__ + "img/mind_skeleton_25.0aa747ed.png";